import type { FaireProductEntity } from "../../entity_types/product";

export const p_b4mkcw2eea: FaireProductEntity = {
  token: "p_b4mkcw2eea",
  type: "product",
  name: "Fruit Assortment Truffle Gift Box 4 Piece",
  brandToken: "b_2p17ktuxx3",
  brandName: "Euphoria Chocolate Company",
  imageUrl:
    "https://cdn.faire.com/fastly/dce55733750929172780e8a74425b131f5cae8bb8ee536e597da98cebde360ff.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5e981f151eac0bf9b3219b8fb224af04136fae2968509959843aee63ab53ffb.jpeg",
  ],
  priceDollars: 9.98,
  description:
    "Rich, fruity ganache dipped in our dark, milk, and white chocolate.\n\nCherry: Dark chocolate ganache made with cherry crumbles, dipped in milk chocolate\nPeach: White chocolate ganache made with peach crumbles, dipped in white chocolate\nRaspberry: Dark chocolate ganache made with raspberry crumbles, dipped in dark chocolate\nStrawberry: White chocolate ganache made with strawberry crumbles, dipped in dark chocolate",
  tags: [],
  msrpDollars: 19.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:06.012Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
